import { render, staticRenderFns } from "./PricingSignal.vue?vue&type=template&id=00b3a76d&"
import script from "./PricingSignal.vue?vue&type=script&lang=js&"
export * from "./PricingSignal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports